import http from '@/libs/AxiosPlugin'

const role = {
  list () {
    return http.get('/role/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: 'admin1', permissions: [{action: 'system', value: 1}, {action: 'people', value: 2}]},
    //     {id: 2, name: 'admin2', permissions: [{action: 'device', value: 3}, {action: 'system', value: 1}]},
    //     {id: 3, name: 'admin3', permissions: [{action: 'order', value: 1}]}
    //   ]
    //   setTimeout(resolve, 100, data)
    // })
  },

  delete (id) {
    return http.post('/role/delete', {id})
  },

  get (id) {
    return http.post('/role/get', {id})
  },

  save (r) {
    return http.post('/role/save', r)
    // return Promise.resolve({ id: r.id, name: 'admin', permissions: [{action: 'system', value: 1}, {action: 'people', value: 2}] })
  }
}

export default role



// WEBPACK FOOTER //
// ./src/api/role.js